// extracted by mini-css-extract-plugin
export default {"receiptValidation":"uploadPaymentOrderReceiptModal_receiptValidation__NUlv0"};